import { useState, useEffect } from "react";
import { getFromApi, postToApi, deleteFromApi } from "../api/auth";

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64  = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw     = window.atob(base64);
    return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
}

export default function PushNotificationBell() {
    const [subscribed, setSubscribed] = useState(false);
    const [loading,    setLoading]    = useState(true);
    const [supported,  setSupported]  = useState(false);

    useEffect(() => {
        if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
            setLoading(false);
            return;
        }
        setSupported(true);
        (async () => {
            try {
                const version = process.env.REACT_APP_GIT_TAG || "dev";
                const reg = await navigator.serviceWorker.register(`/sw.js?v=${version}`);
                reg.update();
                const sub = await reg.pushManager.getSubscription();
                setSubscribed(!!sub);
            } catch {}
            setLoading(false);
        })();
    }, []);

    const toggle = async () => {
        setLoading(true);
        try {
            if (subscribed) {
                const reg = await navigator.serviceWorker.ready;
                const sub = await reg.pushManager.getSubscription();
                if (sub) {
                    await sub.unsubscribe();
                    await deleteFromApi("api/push/unsubscribe");
                }
                setSubscribed(false);
            } else {
                const vapidData = await getFromApi("api/push/vapid-key");
                const reg = await navigator.serviceWorker.ready;
                const sub = await reg.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: urlBase64ToUint8Array(vapidData.publicKey),
                });
                await postToApi("api/push/subscribe", { subscription: sub.toJSON() });
                setSubscribed(true);
            }
        } catch (err) {
            console.error("Push toggle error:", err);
        }
        setLoading(false);
    };

    if (!supported) return null;

    return (
        <button
            onClick={toggle}
            disabled={loading}
            className="btn btn-link p-0 text-dark"
            title={subscribed ? "Disable daily notifications" : "Enable daily notifications"}
            style={{ fontSize: "1.1rem", opacity: loading ? 0.5 : 1 }}
        >
            <i className={`bi ${subscribed ? "bi-bell-fill text-warning" : "bi-bell"}`} />
        </button>
    );
}
